// extracted by mini-css-extract-plugin
export default {"container":"rRHUGXXMci_7ACWh9xVA","mobileLayout":"xB5vzRWk1Xopg5J5erIZ"};